import { render, staticRenderFns } from "./SleepDesc.vue?vue&type=template&id=6116d8fa&scoped=true&"
import script from "./SleepDesc.vue?vue&type=script&lang=ts&"
export * from "./SleepDesc.vue?vue&type=script&lang=ts&"
import style0 from "./SleepDesc.vue?vue&type=style&index=0&id=6116d8fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6116d8fa",
  null
  
)

export default component.exports